module.exports = __webpack_public_path__ + "img/favicon.15b123ca.ico";